import React from 'react'
import { useTokenStats } from '../../dataProvider'
import { mapCoinColor, COINCOLORS, convertToPercents } from '../../helpers'
import GenericChart from '../GenericChart'
import { chainName } from '../../configs/config'

const convertToPercentsHandler = (data) =>
  convertToPercents(data, { totalKey: 'all', ignoreKeys: [] })

export default function PoolAmountChart({ from, to, syncId, tokenStatsItem }) {
  const [tokenStatsData, tokenStatsLoading] = useTokenStats({
    from,
    to,
    chainName: chainName(),
  })

  return (
    <GenericChart
      syncId={syncId}
      loading={tokenStatsLoading}
      title="Pool Composition"
      data={tokenStatsData ? tokenStatsData.poolAmountUsd : null}
      controls={{
        convertToPercents: convertToPercentsHandler,
      }}
      yaxisDataKey="all"
      items={tokenStatsItem}
      type="Area"
    />
  )
}
